var colors = require('./primitives/colors');

var spacing = require('./primitives/spacing');

var typography = require('./primitives/typography');

var theme = require('./theme');

module.exports = {
  theme: theme,
  colors: colors,
  spacing: spacing,
  typography: typography
};